import apiServices from '../api/services'

export const actionTypes = {
	RECEIVE_SERVICES: 'services/RECEIVE_SERVICES',
}

export const getServices = () => async (dispatch) => {
  const response = await apiServices.fetchAllServices()
  dispatch(receiveServices(response))
}

const receiveServices = (services) => ({
  type: actionTypes.RECEIVE_SERVICES,
  data: services,
})



// WEBPACK FOOTER //
// ./src/actions/services.js